import '../../main.css';
import '../../icons.css';
import './ratings.css'

import '../../okta-auth';
import { ENV } from '../../env';

// ! Bootstrap icons
import "bootstrap-icons/font/bootstrap-icons.css";

function loadRatings() {
    // $('#article').load("FireDangerRatings/IDN10018.html");
    return;
}

// Responsive menu/navbar functions
$(window).load(function() {
    loadRatings();
    // Ensure visible on window resize
    $(window).resize(function() {
        if ($(".form-actions.toolbar:hidden").length > 0) {
            $('.form-actions.toolbar').show();
        }
        if ($(".navbar:hidden").length > 0) {
            $('.navbar').show();
        }
    });

    // Hide on Scroll
    $(document).scroll(function() {
        var width = $(window).width();
        if (width < 767) {
            if ($(".form-actions.toolbar:hidden").length == 0) {
                $('.form-actions.toolbar').hide();
            }
            //if ($(".navbar:hidden").length == 0) {
            //    $('.navbar').hide();
            //}
            var scrollA = $('body').scrollTop();
            setTimeout(function() {
                //if (scrollA == $('body').scrollTop() && $(".navbar:hidden").length > 0) {
                //    $('.navbar').slideToggle();
                //}
                if (scrollA == $('body').scrollTop() && $(".form-actions.toolbar:hidden").length > 0) {
                    $('.form-actions.toolbar').slideToggle();
                }
            }, 100);
        }
    })
});